import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/sources")({
  beforeLoad: async () => {
    await ensureRouteTranslationModuleLoaded("sources");
  },
  staticData: {
    title: "apps.sources",
  },
});
